import React from "react";
import { Box, Drawer, useMediaQuery, useTheme } from "@mui/material";

export function InboxColumn({ showChatListMobile, children }) {
  return (
    <Box
      sx={{
        flex: { xs: "1 1 100%", md: "0 0 280px" },
        width: { xs: "100%", md: 280 },
        minWidth: { xs: 0, md: 260 },
        maxWidth: { md: 320 },
        bgcolor: "#ffffff",
        display: {
          xs: showChatListMobile ? "flex" : "none",
          md: "flex",
        },
        flexDirection: "column",
        height: { xs: "auto", md: "100%" },
        maxHeight: { xs: 820, md: "none" },
        minHeight: 0,
        zIndex: 2,
        borderRight: { xs: 0, md: "1px solid #d8e0e5" },
        overflow: "hidden",
      }}
    >
      {children}
    </Box>
  );
}

export function ChatColumn({ showChatListMobile, children }) {
  return (
    <Box
      sx={{
        flex: { xs: "1 1 100%", md: "1 1 auto" },
        width: { xs: "100%", md: "auto" },
        minWidth: { xs: 0, md: 320 },
        bgcolor: "#ffffff",
        display: {
          xs: showChatListMobile ? "none" : "flex",
          md: "flex",
        },
        flexDirection: "column",
        height: { xs: "100vh", md: "100%" },
        minHeight: 0,
        position: "relative",
        overflow: "hidden",
      }}
    >
      {children}
    </Box>
  );
}

const contactPanelSx = {
  flexDirection: "column",
  height: { md: "100%" },
  borderLeft: { md: "1px solid #eaeaea" },
  bgcolor: "#fff",
  minHeight: 0,
  overflow: "hidden",
};

export function ContactColumn({
  mobileOpen = false,
  onMobileClose,
  children,
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  if (isMobile) {
    return (
      <Drawer
        anchor="right"
        open={mobileOpen}
        onClose={onMobileClose}
        ModalProps={{ keepMounted: false }}
        PaperProps={{
          sx: {
            width: "min(100vw, 360px)",
            maxWidth: "100%",
          },
        }}
      >
        <Box sx={{ ...contactPanelSx, height: "100%", display: "flex" }}>
          {children}
        </Box>
      </Drawer>
    );
  }

  return (
    <Box
      sx={{
        flex: { md: "0 0 300px", lg: "0 0 320px" },
        width: { md: 300, lg: 320 },
        minWidth: { md: 280 },
        maxWidth: { md: 340 },
        display: {
          xs: "none",
          md: "flex",
        },
        ...contactPanelSx,
      }}
    >
      {children}
    </Box>
  );
}
